import axios from './axiosConfig'
import { fromGatewayEnvelope } from '@/utils/gatewayError'

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8080'

export type MeterActivityType = 'alert' | 'notification' | 'crmTask'

/**
 * One line of a meter's timeline. `status` is the Gateway's key: open, closed
 * or suppressed for an alert, the delivery status for a message, the task's
 * status key for a CRM task. Only a CRM task has a `statusName`.
 */
export type MeterActivity = {
  type: MeterActivityType
  refId: number
  at: string
  title: string | null
  description: string | null
  status: string | null
  statusName: string | null
  alertId: number | null
}

export type MeterActivityPage = { total: number; rows: MeterActivity[] }

/** The alerts, sent messages and CRM tasks of one meter, newest first. */
export const getMeterActivities = async (
  siteId: string | number,
  meterNumber: string | number,
  options: {
    startDate: string
    endDate: string
    page: number
    size: number
    sortOrder?: 'ASC' | 'DESC'
  }
): Promise<MeterActivityPage> => {
  const res = await axios.get(
    `${API_BASE_URL}/api/notifications/${siteId}/meter/${encodeURIComponent(
      String(meterNumber)
    )}/activities`,
    { params: { sortOrder: 'DESC', ...options } }
  )
  const page: { total?: number; result?: MeterActivity[] } | undefined =
    res.data?.data
  if (!Array.isArray(page?.result)) {
    throw new Error(
      fromGatewayEnvelope(res.data, 'טעינת הפעילויות נכשלה').message
    )
  }
  return { total: page.total ?? 0, rows: page.result }
}
